import React from 'react';

import { Block, withBlockRendering } from '../common/Block.jsx';
import { Builder, BuilderBlock, BuilderControls, EmptyPlaceholder } from '../layout/Builder.jsx';
import { default as Image } from '../common/Image.jsx';
import Name from '../common/Name.jsx';
import PageType from '../common/PageType.jsx';
import Utilities from '../common/Utilities.jsx';

function ColumnsComponent(props) {
    const columnStyle = {};
    const containerProps = {};
    const style = { display: 'flex' };
    Utilities.copyObject(props.style, style);
    if (props.blockConfig) {
        if (props.blockConfig.layout && props.blockConfig.layout.backgroundImage && props.blockConfig.layout.backgroundImage.id && props.blockConfig.layout.backgroundImage.id.length > 0) {
            if (props.imageSize) {
                style.backgroundImage = `url('${Image.url(props.blockConfig.layout.backgroundImage, props.imageSize, props.imageSize)}')`;
            }
            style.backgroundPosition = Block.backgroundPosition(props.blockConfig.layout.backgroundPosition);
            style.backgroundSize = props.blockConfig.layout.backgroundSize || 'contain';
            if (style.backgroundSize != 'cover') {
                style.backgroundRepeat = Block.backgroundRepeat(props.blockConfig.layout);
            }
            containerProps.role = 'img';
            if (props.blockConfig.layout.altText) {
                containerProps['aria-label'] = props.blockConfig.layout.altText;
                containerProps.title = props.blockConfig.layout.altText;
            }
        }
        if (props.blockConfig.block) {
            let prop;
            for (let id in props.blockConfig.block) {
                prop = props.blockConfig.block[id];

                let index = id.indexOf('-');
                if (index < 0) {
                    switch (id) {
                        case 'backgroundColor':
                            style[id] = prop;
                            break;
                    }
                    continue;
                }
                const propName = id.substring(0, index);
                const columnId = id.substring(index + 1);
                const colStyle = columnStyle[columnId] || {};
                let propUnit, propValue = '';
                if (prop != undefined && prop.unit) {
                    propUnit = prop.unit;
                    propValue = (prop.value || '').trim();
                } else {
                    propValue = (prop || '').trim();
                }
                if (propValue != '') {
                    switch (propName) {
                        case 'borderLeftColor':
                        case 'borderLeftWidth':
                            Block._mapBorderProperty(colStyle, 'borderLeft', propName, propValue, propUnit);
                            break;
                        default:
                            colStyle[propName] = propValue;
                            if (propUnit) {
                                colStyle[propName] += propUnit;
                            }
                            break;
                    }
                    columnStyle[columnId] = colStyle;
                }
            }
        }
    }
    let bottom, hasHeight, minWidth, position, top, zIndex;
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit(style, props, { alignment: 'textAlign' }, (propName, propValue, propUnit) => {
        if (props.onLayoutStyleProp && props.onLayoutStyleProp(style, propName, propValue, propUnit)) {
            return true;
        }
        switch (propName) {
            case "altText":
            case 'backgroundPosition':
            case 'backgroundImage':
            case 'backgroundRepeatX':
            case 'backgroundRepeatY':
            case 'backgroundSize':
                return true;
            case 'bottom':
                if (propValue && propUnit) {
                    bottom = `${propValue}${propUnit}`;
                }
                return true;
            case 'maxHeight':
            case 'minHeight':
                hasHeight = hasHeight || propValue && propUnit;
                break;
            case 'minWidth':
                if (propValue && propUnit) {
                    minWidth = `${propValue}${propUnit}`;
                }
                return true;
            case 'position':
                position = propValue;
                return true;
            case 'top':
                if (propValue && propUnit) {
                    top = `${propValue}${propUnit}`;
                }
                return true;
            case 'zIndex':
                zIndex = propValue;
                return true;
        }
    });
    if (minWidth) {
        if (!layoutStyles.containerStyle) {
            layoutStyles.containerStyle = {};
        }
        layoutStyles.containerStyle.minWidth = minWidth;
    }
    if (!props.builder && position == 'fixed') {
        if (!layoutStyles.containerStyle) {
            layoutStyles.containerStyle = {};
        }
        layoutStyles.containerStyle.bottom = bottom;
        layoutStyles.containerStyle.position = 'fixed';
        layoutStyles.containerStyle.top = top;
        layoutStyles.containerStyle.width = '100%';
        layoutStyles.containerStyle.zIndex = zIndex || '1';

        let alignment;
        if (props.blockConfig && props.blockConfig.layout) {
            alignment = props.blockConfig.layout.textAlign;
        }
        switch (alignment) {
            case 'left':
                layoutStyles.containerStyle.left = 0;
                break;
            case 'right':
                layoutStyles.containerStyle.right = 0;
                break;
            default:
                layoutStyles.containerStyle.left = '50%';
                layoutStyles.containerStyle.transform = 'translateX(-50%)';
                break;
        }
    }
    if (props.builder && hasHeight) {
        layoutStyles.style.height = '100%';
    }
    switch (props.pageType) {
        case PageType.Header:
            layoutStyles.style.overflow = undefined;
            break;
    }
    const blocks = props.blocks || [];
    const columns = [];
    if (props.builder) {
        columns.push(<div key={`outline-first`} className="drag-outline-layout-child drag-outline-layout-child-first" />);
    }
    blocks.forEach((d, i) => {
        columns.push(
            <ColumnContainer
                key={i}
                {...props}
                blocks={d}
                blockType={Name.Block.Columns}
                index={i}
                inLayout={true}
                parentStyle={layoutStyles.style}
                style={columnStyle[`col${i + 1}`]} />
        );
        if (props.builder) {
            let className = 'drag-outline-layout-child';
            if (i == blocks.length - 1) {
                className += ' drag-outline-layout-child-last';
            }
            columns.push(<div key={`outline-${i}`} className={className} />);
        }
    });
    let className = 'columns__cont cont--kit__content';
    if (props.inPopup) {
        className += ' popup__content';
    }
    let content = (
        <div className={className} style={layoutStyles.style} {...containerProps}>
            {columns}
        </div>
    );
    if (layoutStyles.containerStyle) {
        content = <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>{content}</div>
    }
    if (props.builder) {
        const _builderBlockProps = props.builderBlockProps || {};
        content = (
            <React.Fragment>
                <BuilderBlock blockType={Name.Block.Columns} {...props} {..._builderBlockProps}>
                    <BuilderControls label="COLUMNS" onBlockMove={props.onBlockMove} />
                    {content}
                    <div className="drag-outline drag-outline-layout drag-outline-layout-parent" />
                </BuilderBlock>
                {
                    props.dragging &&
                    position != 'fixed' &&
                    (!layoutStyles.containerStyle || !layoutStyles.containerStyle.bottom) &&
                    <div id={`${props.blockId}-hidden`} className="hidden draggable" style={{ bottom: 0 }} onDragEnter={props.onDragEnter} />
                }
            </React.Fragment>
        );
    }
    return content;
}

function _ColumnContainer(props) {
    let columnStyle = { display: 'flex', flex: 1, minWidth: 0, position: 'relative', width: '100%' };
    Utilities.copyObject(props.style, columnStyle);
    const isRow = columnStyle.flexDirection != 'column';
    let firstFlex = 0;
    let lastFlex = 0;
    let alignment;
    switch (columnStyle.alignment) {
        case 'tl':
            alignment = 'flex-start';
            lastFlex = 1;
            if (!isRow) {
                columnStyle.alignItems = 'flex-start';
            }
            break;
        case 'tc':
            alignment = 'center';
            if (isRow) {
                firstFlex = 1;
                lastFlex = 1;
            } else {
                columnStyle.alignItems = 'center';
            }
            break;
        case 'tr':
            alignment = 'flex-end';
            if (isRow) {
                firstFlex = 1;
            } else {
                columnStyle.alignItems = 'flex-end';
            }
            break;
        case 'ml':
            alignment = 'flex-start';
            lastFlex = 1;
            if (isRow) {
                columnStyle.alignItems = 'center';
            } else {
                firstFlex = 1;
                columnStyle.alignItems = 'flex-start';
            }
            break;
        case 'mc':
            alignment = 'center';
            firstFlex = 1;
            lastFlex = 1;
            columnStyle.alignItems = 'center';
            break;
        case 'mr':
            alignment = 'flex-end';
            firstFlex = 1;
            if (isRow) {
                columnStyle.alignItems = 'center';
            } else {
                lastFlex = 1;
                columnStyle.alignItems = 'flex-end';
            }
            break;
        case 'bl':
            alignment = 'flex-start';
            if (isRow) {
                lastFlex = 1;
                columnStyle.alignItems = 'flex-end';
            } else {
                firstFlex = 1;
                columnStyle.alignItems = 'flex-start';
            }
            break;
        case 'bc':
            alignment = 'center';
            firstFlex = 1;
            if (isRow) {
                lastFlex = 1;
                columnStyle.alignItems = 'flex-end';
            } else {
                columnStyle.alignItems = 'center';
            }
            break;
        case 'br':
            alignment = 'flex-end';
            firstFlex = 1;
            columnStyle.alignItems = 'flex-end';
            break;
    }
    columnStyle.alignment = undefined;

    let className = 'columns__col';
    if (isRow) {
        className += ' columns__col--horizontal';
    }
    const blocks = props.blocks || [];
    let dataType, id;
    if (props.builder) {
        className += ' layout-cont layout-child';
        if (isRow) {
            className += ' layout-horizontal';
            dataType = 'layout-horizontal';
        } else {
            className += ' layout-vertical';
            dataType = 'layout-vertical';
        }
        id = `${props.blockId}-child-${props.index}`;
    }
    let firstChildMinWidth = '10px';
    const renderedBlocks = props.onBlockRendering(
        props.pageType,
        blocks,
        (d, parentProps) => {
            let blockProps = {};
            if (props.blockHandler) {
                blockProps = props.blockHandler(d, parentProps) || {};
            }
            if (!d.type) {
                return blockProps;
            }
            switch (d.type.value) {
                case Name.Block.Artist.Cell.Image:
                    blockProps.alignment = alignment;
                    break;
            }
            return blockProps;
        },
        (d, blockConfig, parentProps) => {
            let blockProps = {};
            if (props.builderBlockPropsHandler) {
                const additionalProps = props.builderBlockPropsHandler(d, blockConfig, parentProps);
                Utilities.copyObject(additionalProps, blockProps);
            } else {
                blockProps = Builder.handleBlockProps(d, blockConfig, parentProps) || {};
            }
            if (!d.type) {
                return blockProps;
            }
            let style;
            switch (d.type.value) {
                case Name.Block.Artist.ImageV2:
                case Name.Block.ImageV2:
                case Name.Block.Show.ImageV2:
                    if (blockConfig && blockConfig.layout) {
                        if ((blockConfig.layout.width && blockConfig.layout.width.unit == '%' && blockConfig.layout.width.value && blockConfig.layout.width.value.length > 0) ||
                            (blockConfig.layout.maxWidth && blockConfig.layout.maxWidth.unit == '%' && blockConfig.layout.maxWidth.value && blockConfig.layout.maxWidth.value.length > 0)) {
                            style = {};
                            Block.mapStyleConfigProps(style, blockConfig.layout, (propName) => {
                                switch (propName) {
                                    case 'alignItems':
                                    case 'height':
                                    case 'isCropped':
                                    case 'maxHeight':
                                    case 'paddingBottom':
                                    case 'paddingLeft':
                                    case 'paddingRight':
                                    case 'paddingTop':
                                        return true;
                                }
                            })
                        }
                    }
                    if (style) {
                        if (!blockProps.style) {
                            blockProps.style = {};
                        }
                        Utilities.copyObject(style, blockProps.style)
                    }
                    break;
                case Name.Block.Artist.Cell.Image:
                case Name.Block.Blog.Cell.Image:
                case Name.Block.Inventory.RecentlyViewed.Cell.Image:
                case Name.Block.SearchResult.Cell.Image.Artist:
                case Name.Block.SearchResult.Cell.Image.Blog:
                case Name.Block.SearchResult.Cell.Image.Inventory:
                case Name.Block.SearchResult.Cell.Image.Show:
                case Name.Block.Show.Cell.Image:
                    style = {};
                    if (isRow) {
                        style.justifyContent = alignment;
                    } else {
                        style.alignItems = alignment;
                    }
                    if (!blockProps.style) {
                        blockProps.style = {};
                    }
                    Utilities.copyObject(style, blockProps.style);
                    break;
                case Name.Block.Inventory.Image:
                case Name.Block.Parallax:
                case Name.Block.Slider:
                    if (blockConfig && blockConfig.layout) {
                        if (blockConfig.layout.height && blockConfig.layout.height.unit == 'vh' && blockConfig.layout.height.value && blockConfig.layout.height.value.length > 0) {
                            if (!style) {
                                style = {};
                            }
                            style.height = `${blockConfig.layout.height.value}%`;
                        }
                        if (blockConfig.layout.maxHeight && blockConfig.layout.maxHeight.unit == 'vh' && blockConfig.layout.maxHeight.value && blockConfig.layout.maxHeight.value.length > 0) {
                            if (!style) {
                                style = {};
                            }
                            style.maxHeight = `${blockConfig.layout.maxHeight.value}%`;
                        }
                        if (blockConfig.layout.minHeight && blockConfig.layout.minHeight.unit == 'vh' && blockConfig.layout.minHeight.value && blockConfig.layout.minHeight.value.length > 0) {
                            if (!style) {
                                style = {};
                            }
                            style.minHeight = `${blockConfig.layout.minHeight.value}%`;
                        }
                    }
                    if (style) {
                        if (!blockProps.style) {
                            blockProps.style = {};
                        }
                        Utilities.copyObject(style, blockProps.style);
                    }
                    blockProps.pageData = props.pageData;
                    break;
            }
            return blockProps;
        }
    );
    const lastHiddenChildStyle = { flex: lastFlex, minHeight: '10px', minWidth: '10px' };
    if (blocks.length == 0 && props.dragging) {
        if (isRow) {
            lastHiddenChildStyle.marginLeft = props.minWidth || '10px';
            lastHiddenChildStyle.minHeight = props.minHeight || '20px';
        } else {
            lastHiddenChildStyle.marginTop = '10px';
            lastHiddenChildStyle.minWidth = props.minWidth || '10px';
            firstChildMinWidth = props.minWidth || firstChildMinWidth;
            columnStyle.minHeight = props.minHeight;
        }
    }
    let content = (
        <React.Fragment>
            {
                props.builder == true &&
                props.dragging &&
                <div id={`${id}-hidden-first`}
                    className="hidden hidden-child-first draggable"
                    data-type={dataType}
                    style={{ flex: firstFlex, minHeight: '10px', minWidth: firstChildMinWidth }}
                    onDragEnter={props.onDragEnter} />
            }
            {
                !props.dragging &&
                <div className="columns__flex" style={{ flex: firstFlex }} />
            }
            {renderedBlocks}
            {
                !props.dragging &&
                <div className="columns__flex" style={{ flex: lastFlex }} />
            }
            {
                props.builder &&
                <React.Fragment>
                    {
                        blocks.length == 0 &&
                        !props.dragging &&
                        <EmptyPlaceholder minHeight={props.minHeight} minWidth={props.minWidth} />
                    }
                    {
                        props.dragging &&
                        <div id={`${id}-hidden`}
                            className="hidden hidden-child-last draggable"
                            data-type={dataType}
                            style={lastHiddenChildStyle}
                            onDragEnter={props.onDragEnter} />
                    }
                </React.Fragment>
            }
        </React.Fragment>
    );
    return (
        <div className={className} data-block-type={props.blockType} data-type={dataType} id={id} style={columnStyle}>
            {
                props.builder &&
                props.parentStyle &&
                props.parentStyle.paddingTop &&
                <div className="drag-outline-layout-child drag-outline-layout-child-top" />
            }
            {content}
            {
                props.builder &&
                props.parentStyle &&
                props.parentStyle.paddingBottom &&
                <div className="drag-outline-layout-child drag-outline-layout-child-bottom" />
            }
        </div>
    );
}
const ColumnContainer = withBlockRendering(_ColumnContainer);

export default { ChildComponent: ColumnContainer, Component: ColumnsComponent };